<template>
<div >

  <modal name="modalCitar">
    <h3> Seleccione la fecha ne la que desea citar al candidato </h3>
    <br>
    Fecha :
    <input type="date" />

    Hora :
    <input type="time" /> <br>

    <textarea name="name" ></textarea>
  </modal>

  <v-dialog/>

   <label style="font-size:40px;"> En Proceso </label>
      <div v-if="requisiciones.length == 0 ">
        <label style="font-size:32px; color:red;" > No hay Requisiciones en Proceso </label>

      </div>

      <div v-else>
        <article class="message is-link" v-for="reque in requisiciones">
          <div class="message-body">
            <div class="columns">
              <div class="column is-4">
                #{{reque.id}} <span v-html="parseDate(reque.fecha )"></span> <br>
                Gerente de : <b> {{reque.gerente}}  </b> <br>
                Solicita puesto : <b> {{ reque.puesto_requerido }} <b> X {{ reque.vacantes }} </b>  </b> <br>
                Salario : <b>$0.00 - $2500.00</b>
              </div>

              <div class="column is-4" >
                <textarea class="textarea" > {{ reque.requisitos }} </textarea>
              </div>

              <div class="column is-4">
                 <!-- <div >

                 </div> -->
                 <a class="button is-link is-rounded" @click="SelectCandidato(reque.id,$event)" > <font-awesome-icon icon="eye" />   </a>

                 <a v-if="$can('sendProcess', $cookies.get('RhSession').rol )" class="button is-success is-rounded" @click="abrirModalNuevo(reque.id,reque.puesto_requerido,reque.puestos_id)">  <font-awesome-icon icon="plus-circle" /> </a>
                 <a v-else disabled class="button is-success is-rounded" >  <font-awesome-icon icon="plus-circle" /> </a>

                 <a v-if="$can('sendProcess', $cookies.get('RhSession').rol )" class="button is-danger is-rounded" @click="finalizarReq(reque.id)">  <font-awesome-icon icon="times" /> </a>
                 <a v-else disabled class="button is-danger is-rounded" >  <font-awesome-icon icon="times" /> </a>

                  <!-- <div class="tooltip">
                   <span class="tooltiptext">Ver Candidatos</span>
                   <a class="button is-link is-rounded" @click="SelectCandidato(reque.id,$event)" > <font-awesome-icon icon="eye" />   </a>
                  </div>

                  <div class="tooltip">
                   <span class="tooltiptext">Agregar Candidatos</span>
                   <a class="button is-success is-rounded" @click="abrirModalNuevo(reque.id,reque.puesto_requerido,reque.puestos_id)">  <font-awesome-icon icon="plus-circle" /> </a>
                  </div>

                  <div class="tooltip">
                   <span class="tooltiptext">Terminar</span>
                   <a class="button is-danger is-rounded" @click="finalizarReq(reque.id)">  <font-awesome-icon icon="times" /> </a>
                  </div> -->


              </div>
            </div>
            <div class=" bodyListCandidates columns" style="display:none;">
              <div class="column">
                <div v-if="candidatos.length > 0">
                    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" >

                      <tr rowspan="2" v-for="candidato in candidatos">
                        <td>
                          <figure class="image is-64x64">
                            <img class="is-rounded" src="https://bulma.io/images/placeholders/64x64.png">
                          </figure>
                        </td>
                        <td>
                          <b>
                            {{candidato.nombre }}
                            {{candidato.apellido_paterno }}
                            {{candidato.apellido_materno }}
                          </b>
                           <br> <label v-html="getAge(candidato.fecha_nacimiento)">  </label>
                        </td>
                        <td> {{candidato.mail }} <br> +52 {{candidato.telefono }}  </td>
                        <td> CURP :  {{candidato.curp }} <br> R F C : {{candidato.rfc}} </td>
                        <td  > {{candidato.estado_civil }} </td>
                        <td>
                          <div class="tooltip">
                            <a class="button is-primary is-outlined" href="src/assets/jaja.pdf" target="_blank"> <font-awesome-icon icon="file" class="fa-lg" /> </a>
                            <span class="tooltiptext">Curriculum</span>
                          </div>
                        </td>
                        <td v-if="candidato.status_laboral_id == 7 ">
                          <label class="is-danger" style="color:red;"> Rechazado</label>
                        </td>
                        <td v-else-if="candidato.status_laboral_id == 5" >
                          <label class="is-danger" style="color:green;"> Aceptado </label>
                        </td>
                        <td v-else-if="candidato.status_laboral_id == 3" >

                          <div class="tooltip">
                            <a class="button is-primary is-outlined" @click="marcarComoEntrevistado(candidato.id)" > <font-awesome-icon icon="coffee" class="fa-lg" /> </a>
                            <span class="tooltiptext">Marcar Entrevistado</span>
                          </div>

                          <div class="tooltip">
                            <a class="button is-primary is-outlined" @click="fRechazar(candidato)"> <font-awesome-icon icon="times" class="fa-lg" /> </a>
                            <span class="tooltiptext">Rechazar</span>
                          </div>

                          <div class="tooltip">
                            <a disabled class="button is-primary is-outlined" > <font-awesome-icon icon="check" class="fa-lg" /> </a>
                            <span class="tooltiptext">Seleccionar</span>
                          </div>

                        </td>
                        <td v-else-if="candidato.status_laboral_id == 4">

                          <div class="tooltip">
                            <a class="button is-primary "  > <font-awesome-icon icon="coffee" class="fa-lg" /> </a>
                            <span class="tooltiptext">Entrevistado</span>
                          </div>

                          <div class="tooltip">
                            <a class="button is-primary is-outlined" @click="fRechazar(candidato)"> <font-awesome-icon icon="times" class="fa-lg" /> </a>
                            <span class="tooltiptext">Rechazar</span>
                          </div>

                          <div class="tooltip">
                            <a  class="button is-primary is-outlined" @click="fSeleccionar(candidato)" > <font-awesome-icon icon="check" class="fa-lg" /> </a>
                            <span class="tooltiptext">Seleccionar</span>
                          </div>

                        </td>
                        <td v-else >

                          <div class="tooltip">
                            <a class="button is-primary is-outlined" @click="fCitar(candidato)" > <font-awesome-icon icon="calendar-alt" class="fa-lg" /> </a>
                            <span class="tooltiptext">Citar</span>
                          </div>

                          <div class="tooltip">
                            <a class="button is-primary is-outlined" @click="fRechazar(candidato)"> <font-awesome-icon icon="times" class="fa-lg" /> </a>
                            <span class="tooltiptext">Rechazar</span>
                          </div>

                        </td>
                      </tr>
                    </table>
                </div>
                <div v-else>
                   <label style="color:red; font-size:24px;"> No hay candidatos </label>
                </div>

              </div>
            </div>
          </div>
        </article>

      </div>

      <div id="modalRegister" class="modal">
        <div class="modal-background"></div>
        <div class="modal-card" style="width:900px;">
          <header class="modal-card-head">
            <p class="modal-card-title"> Registrar nuevo candidato </p>
            <button @click="closeModal" class="delete" aria-label="close"></button>
          </header>
          <section class="modal-card-body">

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Puesto</label>
              </div>
              <div class="field-body">
                <div class="field is-narrow">
                  <div class="control">
                    {{ uPuesto }}

                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Nombre</label>
              </div>
              <div class="field-body">
                <div class="field is-expanded">
                  <div class="field has-addons">
                    <p class="control is-expanded">
                      <input class="input" type="tel" v-model="uName" id="uName" placeholder="Nombre">
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Apellido</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control is-expanded has-icons-left">
                    <input class="input" type="text" v-model="uApellido" id="uApellido" placeholder="Paterno">
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control is-expanded has-icons-left">
                    <input class="input" type="text" v-model="uApellidoM" id="uApellidoM" placeholder="Materno">
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">CURP/RFC</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control is-expanded has-icons-left">
                    <input class="input" type="text" v-model="uCurp" id="uCurp" placeholder=" C U R P ">
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control is-expanded has-icons-left">
                    <input class="input" type="text" v-model="uRfc" id="uRfc" placeholder=" R F C ">
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Correo</label>
              </div>
              <div class="field-body">
                 <div class="field">
                  <p class="control is-expanded has-icons-left has-icons-right">
                    <input class="input" type="email" v-model="uMail" id="uMail" placeholder="Email" >
                    <span class="icon is-small is-left">
                      <i class="fas fa-envelope"></i>
                    </span>
                    <span class="icon is-small is-right">
                      <i class="fas fa-check"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label"></div>
              <div class="field-body">
                <div class="field is-expanded">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static">
                        +52
                      </a>
                    </p>
                    <p class="control is-expanded">
                      <input class="input" type="tel" v-model="uPhone" id="uPhone" placeholder="Your phone number">
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Estado Civil / Genero </label>
              </div>
              <div class="field-body">
                <div class="field ">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="uCivil" id="uCivil">
                        <option>Soltero/a</option>
                        <option>Casado/a</option>
                        <option>Divorciado/a</option>
                        <option>Viudo/a</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="field ">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="uGenero" id="uGenero" placeholder="Genero">
                        <option>Masculino</option>
                        <option>Femenino</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Lugar de nacimiento</label>
              </div>
              <div class="field-body">
                 <div class="field">
                  <p class="control is-expanded has-icons-left has-icons-right">
                    <input class="input" type="text" v-model="uNacimiento" id="uNacimiento" placeholder="Lugar de nacimiento" >

                    <span class="icon is-small is-right">
                      <i class="fas fa-check"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Nacionalidad</label>
              </div>
              <div class="field-body">
                 <div class="field">
                  <p class="control is-expanded has-icons-left has-icons-right">
                    <input class="input" type="text" v-model="uNacionalidad" id="uNacionalidad" placeholder="Nacionalidad" >

                    <span class="icon is-small is-right">
                      <i class="fas fa-check"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Fecha de nacimiento</label>
              </div>
              <div class="field-body">
                 <div class="field">
                  <p class="control is-expanded has-icons-left has-icons-right">
                    <input class="input" type="date" v-model="uFNacimiento" id="uFNacimiento" placeholder="Fecha de nacimiento" >

                    <span class="icon is-small is-right">
                      <i class="fas fa-check"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Direccion</label>
              </div>
              <div class="field-body">
                 <div class="field">
                  <p class="control is-expanded has-icons-left has-icons-right">
                    <input class="input" type="text" v-model="uDireccion" id="uDireccion" placeholder="Direccion" >

                    <span class="icon is-small is-right">
                      <i class="fas fa-check"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label"> C V </label>
              </div>
              <div class="field-body">
                <div class="field is-narrow">
                  <div class="file has-name is-right">
                    <label class="file-label">
                      <input class="file-input" type="file" name="resume">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload"></i>
                        </span>
                        <span class="file-label">
                          Elegir Archivo
                        </span>
                      </span>
                      <span class="file-name">
                        Curriculum LeonelBermon . sxls
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <br><br>

          </section>
          <footer class="modal-card-foot">
            <button class="button is-success" @click="createCandidato"> Agregar Candidato</button>
            <button  @click="closeModal" class="button"> Cerrar </button>
          </footer>
        </div>
      </div>

      <div id="modalDetails" class="modal">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title"> Detalles de la requisicion </p>
            <button @click="closeModal2" class="delete" aria-label="close"></button>
          </header>
          <section class="modal-card-body">

            <div class="field">
              <label class="label">Fecha</label>
              <div class="control">
                {{detallesRequ.fecha}}
              </div>
            </div>

            <div class="field">
              <label class="label">Gerente</label>
              <div class="control">
                <input class="input" type="email" placeholder="e.g. correo@gmail.com">
              </div>
            </div>

            fecha

            Gerente
            {{detallesRequ.gerente}}

            id
            {{detallesRequ.id}}

          </section>
          <footer class="modal-card-foot">
            <button  @click="closeModal2" class="button"> Cerrar </button>
          </footer>
        </div>
      </div>

</div>
</template>

<script>

import axios from 'axios'
import Cors from 'cors'
import searchMix from '@/components/mixins/mixin'
import moment from 'moment'

import { EventBus } from '@/components/bus.js';



export default {
  data () {
    return {
      menuComponente: 'app-create',
      mail: '',
      pass: '',
      requisiciones: [],
      puestos: [],
      empresas: [],
      reqHumanos: [],
      idpuesto: '',
      requisitos: '',
      iddepartamento: '',
      namepuesto: '',
      idgerente: '',
      fechahoy: '',
      controlSolicitar: 0,
      selectedPuesto: '', /// aqui empieza los datos del usuario
      uName: '',
      uApellido: '',
      uApellidoM: '',
      uMail: '',
      uPhone: '',
      uCivil: '',
      uCurp: '',
      uRfc: '',
      uGenero: '',
      uFNacimiento: '',
      uNacimiento: '',
      uDireccion: '',
      uPuesto: '',
      uRequisicionId: '',
      candidatos: [],
      mostrarLista: 0,
      currentCandidato: '',
      uPuestoid: '',
      salarios: [],
      detallesRequ: [],
      actualreque:'',
      uNacionalidad:''

    }
  },
  created () {
    this.getSalarios()
    this.getRequisiciones()
    this.getRecursosHumanos()
    this.getPuesto()
    this.getEmpresas()
    console.log('lol')
  },
  methods: {
    parseDate:function(data){
      return moment(data,'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    finalizarReq:function( id ){
      var estancia  = this;

      console.log('se presiona finalizar req');
      console.log('con el id de ' + id);

      estancia.$modal.show('dialog', {



        title: 'Finalizar Requisicion ',
        text: 'Esta seguro que desea finalizar la requisicion  ? ' + ' <br> <b> ' + id + '</b>',
        buttons: [
          {
            title: 'Si, Finalizar',
            handler: () => {

              axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/update', {
                table: 'requisicion',
                set: ' status_requisicion_id = 3 ',
                where: ` id = ${id} `
              })
                .then(function (response) {
                  if (response.status == 200) {

                    console.log('respuesta del update');
                    console.log(response);

                    estancia.$snotify.error('Requisicion Finalizada ', 'Finalizado', {
                      timeout: 2500,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true
                    })

                    estancia.$modal.hide('dialog')
                    estancia.getRequisiciones()
                    //estancia.SelectCandidato2(estancia.actualreque);

                  } else {
                    console.log('error: No cancelado')
                  }
                })

            }

          },
          {
            title: 'Close'
          }
        ]
      })

    },
    marcarComoEntrevistado:function(id){
      var estancia = this;
      console.log('hola como estas ');
      console.log('se marca como entrevistado al candidato ' + id);

      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/update', {
        table: 'recursos_humanos',
        set: ` status_laboral_id = 4 `,
        where: ` id = '${id}' `
      })
        .then(function (response) {
          if (response.status == 200) {

            estancia.$snotify.success('Se marca como entrevistado al candidato', 'Entrevistado', {
              timeout: 2500,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true
            })

            //hola como estas amiguito
            estancia.SelectCandidato2(estancia.actualreque);

            // estancia.$modal.hide('dialog')
          } else {
            console.log('error: No cancelado')
          }
        })


    },
    fCitar: function (candidato) {
      var estancia = this
      this.$modal.show('dialog', {
        title: 'Citar ',
        text: `<h3> Seleccione Fecha de cita para  </h3> <br><br> <b> ${ candidato.nombre} ${ candidato.apellido_paterno} </b> <br><br>  <br>Fecha <input class='input' id="dateCita" type="date" >  <br> Hora <input class='input' id="timeCita" type="time" > <br> <textarea class='textarea' id="areaC" > </textarea>  `,
        buttons: [
          {
            title: 'Si, Agendar cita',
            handler: () => {
              var fechaC = $('#dateCita').val()
              var horaC = $('#timeCita').val()
              var areaC = $('#areaC').val()

              if (horaC == '' || fechaC == '' || areaC == '') {
                alert('no puede dejar campos vacios')
              } else {
                console.log('aqui se imprime los datos de la cita')
                console.log('horaC' + horaC)
                console.log('fechaC' + fechaC)
                console.log('areaC' + areaC)



                estancia.insertRegistro($cookies.get('RhSession').name, 'recursos_humanos' , candidato.id, ' se agenda la cita   ', ' - ');

                // ACTUALIZAMOS LA REQUISICION
                axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/update', {
                  table: 'recursos_humanos',
                  set: ` status_laboral_id = 3 `,
                  where: ` id = '${candidato.id}' `
                })
                  .then(function (response) {
                    if (response.status == 200) {
                      estancia.$snotify.success('Se ha creado la cita para el candidato', 'Cita creada', {
                        timeout: 2500,
                        showProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true
                      })

                      //hola como estas amiguito
                      estancia.SelectCandidato2(estancia.actualreque);

                      estancia.$modal.hide('dialog')
                    } else {
                      console.log('error: No cancelado')
                    }
                  })

                //  CREAMOS LA CITAsi, agendada
                axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/write', {
                  table: 'citas',
                  columns: 'rhId, fecha, hora, descripcion, status_general_id, created_at',
                  values: ` '${estancia.$cookies.get('RhSession').name}', '${fechaC}', '${horaC}','${areaC}',1, '${moment().format('YYYY-MM-DD')}' `
                })
                  .then(function (response) {
                    if (response.status == 200) {

                    } else {
                      console.log('error')
                    }
                  })
              }
            }

          },
          {
            title: 'Close'
          }
        ]
      })
    },
    leervacantes:function(actualReq){
      console.log('llega a leervacantes');
      console.log('con los datos de la requisicion : '+ actualReq);

      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: 'id, vacantes',
        table: 'requisicion',
        where: 'id = '+actualReq,
        condition: ''
      })
        .then(function (response) {
          if (response.status == 200) {

            console.log('respuesta de leevacantes ');
            console.log(response);
            console.log(reponse.data);
            console.log(reponse.data.vacantes);

          } else {
            console.log('error')
          }
        })

    },
    fSeleccionar: function (candidato) {
      console.log('se presiona aceptar al candidatro ');
      var estancia = this
      this.$modal.show('dialog', {
        title: 'Seleccionar',
        text: 'Seguro que desea seleccionar al candiato ? ' + ' <br> <b> ' + candidato.nombre +" " + candidato.apellido_paterno +" " + candidato.apellido_materno + '</b>',
        buttons: [
          {
            title: 'Si, Seleccionar',
            handler: () => {
              axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/update', {
                table: 'recursos_humanos',
                set: ` status_laboral_id = 5 `,
                where: ` id = '${candidato.id}' `
              })
                .then(function (response) {
                  if (response.status == 200) {

                    estancia.$snotify.success('Se Acepto al candidato', 'Aceptado', {
                      timeout: 2500,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true
                    })


                    //aqui se consulta las vacantes para saber cuantas quedan y si ya se termina una vez seleccionando
                    estancia.leervacantes(estancia.actualreque);


                    estancia.SelectCandidato2(estancia.actualreque); //mostramos de nuevo los candidatos actualizados
                    estancia.$modal.hide('dialog')

                  } else {
                    console.log('error: No cancelado')
                  }
                })
            }

          },
          {
            title: 'Close'
          }
        ]
      })
    },
    fRechazar: function (candidato) {
      var estancia = this

      estancia.insertRegistro($cookies.get('RhSession').name, 'recursos_humanos' , candidato.id, ' se rechaza al candidato  ', ' - '); // *** guardamos el movimiento


      this.$modal.show('dialog', {
        title: 'Rechazar',
        text: 'Seguro que desea rechazar al candiato ? ' + ' <br> <b> ' + candidato.nombre + '</b>',
        buttons: [
          {
            title: 'Si, rechazar',
            handler: () => {
              axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/update', {
                table: 'recursos_humanos',
                set: ` status_laboral_id = 7 `,
                where: ` id = '${candidato.id}' `
              })
                .then(function (response) {
                  if (response.status == 200) {
                    estancia.$snotify.error('Se rechazo al usuario', 'Rechazado', {
                      timeout: 2500,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true
                    })
                    estancia.$modal.hide('dialog')

                    estancia.SelectCandidato2(estancia.actualreque);

                  } else {
                    console.log('error: No cancelado')
                  }
                })
            }

          },
          {
            title: 'Close'
          }
        ]
      })
    },
    show: function () {
      this.$modal.show('modalReject')

      // this.$modal.show('hello-world', {
      //   title: 'Alert!',
      //   text: 'You are too awesome',
      //   buttons: [
      //     {
      //       title: 'Deal with it',
      //       handler: () => { alert('Woot!') }
      //     },
      //     {
      //       title: '',       // Button title
      //       default: true,    // Will be triggered by default if 'Enter' pressed.
      //       handler: () => {} // Button click handler
      //     },
      //     {
      //       title: 'Close'
      //     }
      //  ]
      // })
    },
    hide: function () {
      this.$modal.hide('hello-world')
    },
    getAge: function (fecha) {
      console.log('function get age procceess')
      console.log(moment().diff(fecha, 'years'))

      return moment().diff(fecha, 'years') + ' Años '
    },
    previewDetails: function (item) { // hola
      console.log('hola como estas')
      console.log('previsualizar los detalles de la requisicion')

      // aqui se manda obtinene todos los datos
      var estancia = this
      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: '*',
        table: 'requisicion',
        where: 'id =' + item,
        condition: ''
      })
        .then(function (response) {
          if (response.status == 200) {
            console.log('los detalles de la requisicion')
            console.log(response.data[0])

            estancia.detallesRequ = response.data[0]
            $('#modalDetails').addClass('is-active')
          } else {
            console.log('error')
          }
        })
    },
    getSueldo: function (indice) {

    },
    getSalarios: function () {

    },
    updateRecursosHumanos: function (requisicionid) {
      console.log('aqui entra en la funcion de actualizar updtaeRecursosHumanos')
      var table = 'requisicion'
      var set = 'status_requisicion_id = 3 '
      var where = `id = ${requisicionid} `
      axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=updateFromWhere&table=${table}&set=${set}&where=${where}`)
        .then(function (response) {
          console.log('respuesta ')
          console.log(response)

          if (response.status == 200) {
            estancia.mostrarLista = 1
            $('#modalSelectCandidatos').removeClass('is-active')

            console.log('SE ACTUALIZA LA REQUISICION ')
          } else {
            console.log('error')
          }
        })
    },
    contratarUser: function (userid, requisicionid) {
      console.log('entra en la funcion de ++++++ contratar')

      console.log(' vamos a contratar al usuario ' + userid)
      console.log('requisicion id' + requisicionid)

      var estancia = this

      var table = 'recursos_humanos'
      var set = 'status_laboral_id = 2 '
      var where = `id = ${userid} `

      // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=updateFromWhere&table=${table}&set=${set}&where=${where}`)
      // .then(function(response){
      //   console.log('respuesta ');
      //   console.log(response);
      //
      //   if (response.status == 200 ) {
      //       estancia.mostrarLista = 1;
      //       estancia.updateRecursosHumanos( requisicionid ); //funcion para actualizar la requisicion
      //       $('#modalSelectCandidatos').removeClass("is-active");
      //
      //       console.log('SE CONTRTATO AL CANDIDATO');
      //   }else{
      //     console.log('error');
      //   }
      // });
    },
    agendarCita: function (userid, requid) {
      var fecha = $('#fechaCita').val()
      var time = $('#horaCita').val()
      var actualDate = moment().format('YYYY-MM-DD HH:mm:ss')

      if (fecha == '' || time == '') {
        alert('debe seleccionar Hora y Fecha')
      } else {
        this.mostrarLista = 1
        $('#modalSelectCandidatos').removeClass('is-active')

        // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=insertCita&requisicion_id=${requid}&candidato_id=${userid}&fecha=${fecha}&hora=${time}&created_at=${actualDate}`)
        // .then(function(response){
        //   console.log('respuesta ');
        //   console.log(response);
        //
        //   if (response.status == 200 ) {
        //       estancia.mostrarLista = 1;
        //       $('#modalSelectCandidatos').removeClass("is-active");
        //   }else{
        //     console.log('error');
        //   }
        // });
      }
    },
    updateFrom: function (id, table, number) { // aqui se actualiza, el estatus a 5 . RECHAZADO
      console.log('entra en la funcion updateFrom')
      var estancia = this
      var table = table
      var set = `status_laboral_id = ${number} `
      var where = `id = ${id}`

      axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=updateFromWhere&table=${table}&set=${set}&where=${where}`)
        .then(function (response) {
          console.log('respuesta ')
          console.log(response)

          if (response.status == 200) {
            estancia.mostrarLista = 1
            $('#modalSelectCandidatos').removeClass('is-active')
          } else {
            console.log('error')
          }
        })
    },
    showCandidato: function (id) {

      // this.mostrarLista = 1;
      // var estancia = this;
      // var table = 'recursos_humanos'
      // var where = ` id = ${id}  `;
      // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=getFromWhere&table=${table}&where=${where}`)
      // .then(function(response){
      //
      //   estancia.currentCandidato = response.data;
      //
      // });

    },
    closeModalCandi2: function () {
      $('#modalSelectCandidatos').removeClass('is-active')
      this.mostrarLista = 0
    },
    closeModal2: function () {
      $('#modalDetails').removeClass('is-active')
    },

    SelectCandidato: function (reqId, e) {
      $('.bodyListCandidates').hide()
      $(e.target).parent().parent().parent().next().show()

      this.actualreque = reqId;

      var estancia = this
      var table = 'recursos_humanos'
      var where = `requisicion_id =${reqId} AND status_laboral_id = 1 `

      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: '*',
        table: 'recursos_humanos',
        where: 'requisicion_id = ' + reqId,
        condition: ' '
      })
        .then(function (response) {
          estancia.candidatos = response.data
        })
    },

    SelectCandidato2: function (reqId) {

      var estancia = this
      var table = 'recursos_humanos'
      var where = `requisicion_id =${reqId} AND status_laboral_id = 1 `

      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: '*',
        table: 'recursos_humanos',
        where: 'requisicion_id = ' + reqId,
        condition: ' '
      })
        .then(function (response) {
          estancia.candidatos = response.data
        })
    },

    closeModal: function () {
      $('#modalRegister').removeClass('is-active')
    },

    abrirModalNuevo: function (requisicion, puesto, puestoid) {
      this.uRequisicionId = requisicion
      this.uPuesto = puesto
      this.uPuestoid = puestoid



      console.log('abrirModalNuevo')
      $('#modalRegister').addClass('is-active')
    },
    getCandidatos: function () {
      console.log('funcion')
    },
    createCandidato: function () {
      var estancia = this
      console.log('entra a agregar usuarios')

      this.insertRegistro($cookies.get('RhSession').name, 'recursos_humanos' , estancia.uName, ' Se da de alta al candidato con nombre  ', ' - ');

      if (this.uName == '' || this.uApellido == '' || this.uApellidoM == '' || this.uMail == '' || this.uPhone == '' || this.uCivil == '' || this.uNacimiento == '' || this.uDireccion == '' || this.uPuesto == '' || this.uRfc == '' || this.uCurp == '' || this.uGenero == '' || this.uFNacimiento == '') {
        (this.uName == '') ? $('#uName').css('border-color', 'red') : $('#uName').css('border-color', '#b5b5b5');
        (this.uApellido == '') ? $('#uApellido').css('border-color', 'red') : $('#uApellido').css('border-color', '#b5b5b5');
        (this.uApellidoM == '') ? $('#uApellidoM').css('border-color', 'red') : $('#uApellidoM').css('border-color', '#b5b5b5');
        (this.uMail == '') ? $('#uMail').css('border-color', 'red') : $('#uMail').css('border-color', '#b5b5b5');
        (this.uPhone == '') ? $('#uPhone').css('border-color', 'red') : $('#uPhone').css('border-color', '#b5b5b5');
        (this.uCivil == '') ? $('#uCivil').css('border-color', 'red') : $('#uCivil').css('border-color', '#b5b5b5');
        (this.uNacimiento == '') ? $('#uNacimiento').css('border-color', 'red') : $('#uNacimiento').css('border-color', '#b5b5b5');
        (this.uDireccion == '') ? $('#uDireccion').css('border-color', 'red') : $('#uDireccion').css('border-color', '#b5b5b5');
        (this.uRfc == '') ? $('#uRfc').css('border-color', 'red') : $('#uRfc').css('border-color', '#b5b5b5');
        (this.uCurp == '') ? $('#uCurp').css('border-color', 'red') : $('#uCurp').css('border-color', '#b5b5b5');
        (this.uGenero == '') ? $('#uGenero').css('border-color', 'red') : $('#uGenero').css('border-color', '#b5b5b5');
        (this.uFNacimiento == '') ? $('#uFNacimiento').css('border-color', 'red') : $('#uFNacimiento').css('border-color', '#b5b5b5')
      } else {
        axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/write', {

          table: 'recursos_humanos',
          columns: 'nombre,apellido_paterno, apellido_materno, direccion, lugar_nacimiento, estado_civil, telefono, mail, status_laboral_id, puestos_id, empresa_id, requisicion_id, created_at, curp, rfc, fecha_nacimiento, genero, nacionalidad',
          values: ` '${estancia.uName.toUpperCase()}', '${estancia.uApellido.toUpperCase()}','${estancia.uApellidoM.toUpperCase()}','${estancia.uDireccion.toUpperCase()}','${estancia.uNacimiento}', '${estancia.uCivil.toUpperCase()}', '${estancia.uPhone}','${estancia.uMail}',1, '${estancia.uPuestoid}',999, '${estancia.uRequisicionId}','${moment().format('YYYY-MM-DD HH:mm:ss')}','${estancia.uCurp.toUpperCase()}','${estancia.uRfc.toUpperCase()}','${estancia.uFNacimiento}','${estancia.uGenero}','${estancia.uNacionalidad}' `

          // nombre : estancia.uName,
          // apellido_paterno : estancia.uApellido,
          // apellido_materno : estancia.uApellidoM,
          // mail : estancia.uMail,
          // telefono : estancia.uPhone,
          // estado_civil : estancia.uCivil,
          // lugar_nacimiento : estancia.uNacimiento,
          // direccion : estancia.uDireccion,
          // puestos_id : estancia.uPuestoid,
          // rfc:estancia.uRfc,
          // curp: estancia.uCurp,
          // created_at : moment().format('YYYY-MM-DD HH:mm:ss'),
          // requisicion_id : estancia.uRequisicionId
        })
          .then(function (response) {
            console.log('termina de hacer query')
            console.log(response)
            if (response.status == 200) {
            // alert('usuario ingresado correctamente ');

            estancia.SelectCandidato2(estancia.actualreque);

              estancia.$snotify.success('Candidato agregado', 'Agregado', {
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true
              })

              //EventBus.$emit('cambioCompon', 'hola desde marte');

              // inicializar todo
              $('#modalRegister').removeClass('is-active')

              estancia.uName = ''
              estancia.uApellido = ''
              estancia.uApellidoM = ''
              estancia.uMail = ''
              estancia.uPhone = ''
              estancia.uCivil = ''
              estancia.uNacimiento = ''
              estancia.uDireccion = ''
              estancia.uPuesto = ''
              estancia.uPuestoid = ''
              estancia.uEmpresa = 0

              // estancia.SelectCandidato(estancia.uPuestoid );
            } else {
              console.log('error')
            }
          })
      }
    },
    getPuesto: function () {
      // var estancia = this;
      // console.log('puestos');
      //
      // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=getFrom&table=puestos`)
      // .then(function(response){
      //
      //   if (response.status == 200 ) {
      //     console.log('respuesta'+response);
      //     estancia.puestos = response.data;
      //   }else{
      //     console.log('error');
      //   }
      //
      // });

    },
    getEmpresas: function () {
      // var estancia = this;
      // console.log('puestos');
      //
      // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=getFrom&table=empresa`)
      // .then(function(response){
      //
      //   if (response.status == 200 ) {
      //     console.log('respuesta'+response);
      //     estancia.empresas = response.data;
      //   }else{
      //     console.log('error');
      //   }
      //
      // });

    },
    createNewCandidato: function () {
      $('.modal').modal('open')
    },
    getRequisiciones: function () {
      var estancia = this
      var where = `status_requisicion_id = 1 ORDER BY fecha DESC `
      // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=getFromWhere&table=requisicion&where=${where}`)
      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: '*',
        table: 'requisicion',
        where: 'status_requisicion_id = 1 ',
        condition: 'ORDER BY fecha DESC'
      })
        .then(function (response) {
          if (response.status == 200) {
            estancia.requisiciones = response.data
          } else {
            console.log('error')
          }
        })
    },
    getRecursosHumanos: function () {
      var estancia = this
      // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=getFrom&table=recursos_humanos`)
      // .then(function(response){
      //   if (response.status == 200 ) {
      //     estancia.reqHumanos  = response.data;
      //   }else{
      //     console.log('error');
      //   }
      // });
    }

  },
  mixins: [searchMix]

}
</script>
